export const WageVI =
    {
        "wageTable": "Bảng lương",
        "wage": "Bảng lương",
        "wageReportTax": "Quyết toán thuế",
        "wageRecipe": "Công thức và từ khóa",
        "wageReport": "Báo cáo",
        "wageTemplate": "Cấu hình bảng lương",
        "wageNotify": "Gửi thông báo",
    }
